var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Link, Stack, Typography, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
var StyledDialogContent = styled(DialogContent)({
  display: 'flex',
  flexDirection: 'column',
  gap: 16
});
var ScrollableList = styled(Box)({
  overflowY: 'auto',
  maxHeight: '50vh'
});
export var ReviewMissingDataModal = function (_a) {
  var open = _a.open,
    onClose = _a.onClose,
    missingData = _a.missingData,
    onNavigate = _a.onNavigate,
    isViewOnly = _a.isViewOnly;
  var t = useTranslation().t;
  var tReview = useTranslation('orgConfig', {
    keyPrefix: 'orgConfigWizard.reviewStep'
  }).t;
  return _jsxs(Dialog, __assign({
    open: open,
    onClose: onClose,
    maxWidth: "sm",
    fullWidth: true
  }, {
    children: [_jsx(DialogTitle, __assign({
      variant: "h2"
    }, {
      children: tReview('missingDataModalTitle')
    })), _jsx(StyledDialogContent, {
      children: missingData.length === 0 ? _jsx(Typography, {
        children: tReview('noMissingData')
      }) : _jsxs(Stack, __assign({
        spacing: 2
      }, {
        children: [_jsx(Typography, {
          children: tReview('missingDataModalDescription')
        }), _jsx(ScrollableList, {
          children: _jsx(Stack, __assign({
            spacing: 2
          }, {
            children: missingData.map(function (entry) {
              return _jsxs(Box, {
                children: [isViewOnly ? _jsx(Typography, __assign({
                  variant: "body1",
                  fontWeight: "bold"
                }, {
                  children: entry.label
                })) : _jsx(Link, __assign({
                  component: "button",
                  variant: "body1",
                  fontWeight: "bold",
                  onClick: function () {
                    onClose();
                    onNavigate(entry.step);
                  }
                }, {
                  children: entry.label
                })), _jsx(Box, __assign({
                  component: "ul",
                  sx: {
                    mt: 0.5,
                    mb: 0,
                    pl: 3,
                    listStylePosition: 'inside'
                  }
                }, {
                  children: entry.locationNames.map(function (name) {
                    return _jsx(Box, __assign({
                      component: "li"
                    }, {
                      children: _jsx(Typography, __assign({
                        variant: "body2",
                        component: "span"
                      }, {
                        children: name
                      }))
                    }), name);
                  })
                }))]
              }, entry.step);
            })
          }))
        })]
      }))
    }), _jsx(DialogActions, __assign({
      sx: {
        justifyContent: 'flex-end'
      }
    }, {
      children: _jsx(Button, __assign({
        variant: "outlined",
        onClick: onClose
      }, {
        children: t('action.close')
      }))
    }))]
  }));
};